/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from 'react';
import { TriggerNodeModel } from './TriggerNodeModel';
import { AbstractReactFactory } from '@projectstorm/react-canvas-core';
import NodeWidgetHOC from '../NodeWidgetHOC/NodeWidgetHOC';
import BaseNodeWidget from '../NodeWidgetHOC/BaseNodeWidget';
import NodeTypes from '../BaseNodeModel/NodeTypes';

export class TriggerNodeFactory extends AbstractReactFactory {
  constructor() {
    super(NodeTypes.TRIGGER_NODE);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  generateModel(event) {
    return new TriggerNodeModel();
  }

  generateReactWidget(event) {
    const setInputFields = ({ templateId, specs }) =>
      event.model.setInputFields(templateId, specs);

    return (
      <NodeWidgetHOC node={event.model}>
        <BaseNodeWidget
          engine={this.engine}
          node={event.model}
          setInputFields={setInputFields}
        />
      </NodeWidgetHOC>
    );
  }
}
